import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { BasketItemComponentDef } from '@df/basket/view/basket-item.component.def';
import { ImageModule } from '@df/module-image/image.module';
import { OptionLabelPipe } from '@df/ui/common/option-label.pipe';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { LocalProduct } from '../catalog/model/product/product.decorator';
import { LocalBasketItem } from '../customer/basket/basket-item.decorator';
import { ActionComponent } from '../ui/api/action.component';
import { ResultComponent } from '../ui/resut/result.component';
import { BasketBundleOptionsComponent } from './bundle-options/basket-bundle-options.component';
import { ItemQtyComponent } from './item-qty.component';
import { IProductDataV3 } from '@df/catalog/product/product';
declare module '@tomandco/nexus-api-types' {
    namespace Nexus.Lib.Basket {
        interface BasketItem {
            am_giftcard_image_url?: string;
        }
    }
}
@Component({
    selector: 'basket-item',
    templateUrl: './basket-item.html',
    styleUrls: ['./basket-item.scss'],
    standalone: true,
    imports: [
        ActionComponent,
        BasketBundleOptionsComponent,
        ImageModule,
        NgClass,
        ItemQtyComponent,
        OptionLabelPipe,
        PriceComponent,
        ResultComponent,
        RouterLink,
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class BasketItemComponent extends BasketItemComponentDef<LocalBasketItem> {
    declare product?: LocalProduct<IProductDataV3>;

    protected get image(): string | undefined {
        return this.item!.data.am_giftcard_image_url || this.product?.data?.image;
    }
}
